import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import SidebarNavMenu from "../../SidebarMenus/components/SidebarNavMenu";
import RetailerShowItem from "./RetailerShowItem";
import RetailerEditItem from "./RetailerEditItem";
import RetailerFeedsItem from "./RetailerFeedsItem";
import RetailerProductListItem from "./RetailerProductListItem";

import {ReactComponent as ShopIcon} from "assets/img/shop.svg";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../SidebarContext";

RetailerMenu.propTypes = {
    retailer: PropTypes.shape({
        id: PropTypes.string.isRequired
    }).isRequired
};

function RetailerMenu({retailer}) {
    const {currentPath} = useContext(SidebarContext);

    if (!retailer) {
        return null;
    }

    const isOpen = !!(
        currentPath.includes(MarketplaceRoutes.RETAILER_SHOW(retailer.id))
        || currentPath === MarketplaceRoutes.RETAILER_EDIT(retailer.id)
        || currentPath === MarketplaceRoutes.RETAILER_PROFILE(retailer.id)
    );

    return (
        <>
            <SidebarNavMenu
                open={isOpen}
                icon={<ShopIcon />}
                content={retailer.name}
            >
                <RetailerShowItem retailerId={retailer.id} />
                <RetailerEditItem retailerId={retailer.id} />
                <RetailerProductListItem retailerId={retailer.id} />
                <RetailerFeedsItem retailerId={retailer.id} />
            </SidebarNavMenu>
        </>
    );
}

export default RetailerMenu;
